import { create } from 'zustand';
import { ModalType } from '../../enum/EnumRepository';

export interface StandardModal {
  modalType: ModalType;
  title: string | null;
  value: string | null;
  data?: File[];
  handleChange: (value: string, payload?: unknown) => void;
  option?: boolean;
}

interface standardModalState {
  standardModal: StandardModal | null;
  isClosing: boolean;
  setStandardModal: (standardModal: StandardModal) => void;
  clearModal: (time?: number) => void;
}

export const useModalStore = create<standardModalState>()((set) => {
  let closeTimer: ReturnType<typeof setTimeout> | null = null;

  const cancelClose = () => {
    if (!closeTimer) return;
    clearTimeout(closeTimer);
    closeTimer = null;
  };

  return {
    standardModal: null,
    isClosing: false,
    setStandardModal: (standardModal: StandardModal) => {
      cancelClose();
      set({ standardModal, isClosing: false });
    },
    clearModal: (time: number = 300) => {
      cancelClose();
      set({ isClosing: true });

      closeTimer = setTimeout(() => {
        closeTimer = null;
        set({ standardModal: null, isClosing: false });
      }, time);
    },
  };
});
